import { render, staticRenderFns } from "./proveedores.view.vue?vue&type=template&id=2bd84508"
import script from "./proveedores.view.vue?vue&type=script&lang=js"
export * from "./proveedores.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports